module.exports = __webpack_public_path__ + "static/media/ic-contrato-faturacao.dee4b09b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Svg/ic-contrato-faturacao.svg
// module id = 1225
// module chunks = 0